import React from "react";

export function TextHeader({ columnSchema }) {
  const { label } = columnSchema;
  return <div className="cp-ellipsis">{label}</div>;
}
